import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mr-4 text-caption font-weight-medium"
}

import { ref, onMounted } from 'vue'
import SnackbarNotification from '@/components/SnackbarNotification.vue'
import ResetTimer from '@/components/ResetTimer.vue'
import { StorageService } from '@/services/storageService';

// State for controlling drawer and mini-variant mode

export default /*@__PURE__*/_defineComponent({
  __name: 'MainLayout',
  setup(__props) {

// Import necessary Vue and Vuetify features
const drawer = ref(true)
const miniVariant = ref(window.innerWidth < 1600 && window.innerWidth >= 1280)

// Menu items to display in the navigation drawer
const menuItems = ref([
  { title: 'Home', path: '/', icon: 'mdi-home', color: 'alliance' },
  { title: 'Tasks', path: '/tasks', icon: 'mdi-checkbox-marked-circle-outline', color: 'primary' },
  { title: 'Reputations', path: '/reputations', icon: 'mdi-shield-star', color: 'purple' },
  { title: 'Mounts', path: '/mounts', icon: 'mdi-horse', color: 'brown' },
  { title: 'Calendar Events', path: '/calendar', icon: 'mdi-calendar', color: 'blue' },
  { title: 'Settings', path: '/settings', icon: 'mdi-cog', color: 'grey' }
])

// Title for the banner
const title = ref('WoWeekly')

// Add a reactive variable to track the character name
const characterName = ref('')

// Watch for character updates from the storage service
onMounted(() => {
  const storedCharacter = StorageService.getCharacterInfo()
  if (storedCharacter) {
    // Capitalize the first letter of the character name
    characterName.value = storedCharacter.name.charAt(0).toUpperCase() + storedCharacter.name.slice(1)
  }
})

// Handle window resize to update miniVariant
window.addEventListener('resize', () => {
  if (window.innerWidth < 1600 && window.innerWidth >= 1280) {
    miniVariant.value = true
  } else if (window.innerWidth >= 1600) {
    miniVariant.value = false
  }
})

// Add a red button for clearing all data
const clearDataButton = {
  title: 'Clear All Data',
  action: () => {
    if (confirm('Are you sure you want to clear all data? This action cannot be undone.')) {
      StorageService.clearAllData();
      location.reload();
    }
  },
  icon: 'mdi-delete',
  color: 'red'
};

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_app_bar, {
        app: "",
        elevation: "6"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_app_bar_nav_icon, {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (drawer.value = !drawer.value), ["stop"]))
          }),
          _createVNode(_component_v_toolbar_title, {
            class: "wow-title",
            style: {"text-transform":"none"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(title.value), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          (characterName.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, " Hello, " + _toDisplayString(characterName.value) + "! ", 1))
            : _createCommentVNode("", true),
          _createVNode(ResetTimer, { class: "mr-4" })
        ]),
        _: 1
      }),
      _createVNode(_component_v_navigation_drawer, {
        modelValue: drawer.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((drawer).value = $event)),
        app: "",
        temporary: _ctx.$vuetify.display.mdAndDown,
        permanent: _ctx.$vuetify.display.lgAndUp,
        rail: miniVariant.value,
        elevation: "4",
        border: "opacity-25"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_divider, { class: "border-opacity-25" }),
          _createVNode(_component_v_list, { nav: "" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(menuItems.value, (item) => {
                return (_openBlock(), _createBlock(_component_v_list_item, {
                  key: item.title,
                  to: item.path,
                  link: "",
                  "prepend-icon": item.icon,
                  color: item.color || 'primary',
                  rounded: "lg",
                  class: "mb-1"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list_item_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.title), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["to", "prepend-icon", "color"]))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          clearDataButton
            ? (_openBlock(), _createBlock(_component_v_list_item, {
                key: 0,
                onClick: clearDataButton.action,
                link: "",
                "prepend-icon": clearDataButton.icon,
                color: clearDataButton.color,
                rounded: "lg",
                class: "mt-3 d-flex align-center justify-center",
                style: {"position":"absolute","bottom":"16px","left":"16px","right":"16px","background-color":"red","color":"white","text-align":"center"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item_title, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(clearDataButton.title), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onClick", "prepend-icon", "color"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "temporary", "permanent", "rail"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, { fluid: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_router_view)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(SnackbarNotification)
    ]),
    _: 1
  }))
}
}

})